<template>
  <div class="circle container">
    <div class="">
      <h2 class="title is-3">
        Opret kreds
      </h2>

      <div class="columns">
        <b-field label="Navn"
                 class="column">
          <b-input v-model="formCircle.title" />
        </b-field>
      </div>

      <div class="columns">
        <b-field class="column align-left">
          <b-checkbox v-model="formCircle.showOverallocation">Vis overallokering</b-checkbox>
        </b-field>
      </div>

      <!-- TODO: Are there other types? -->
      <div class="columns">
        <b-field label="Type"
                 class="column">

          <b-select disabled
                    expanded
                    placeholder="work"
                    v-model="formCircle.type">
            <option value="WORK"
                    selected>Work</option>
          </b-select>
        </b-field>
      </div>

      <div class="columns">
        <b-field label="Kode"
                 class="column">
          <b-input v-model="formCircle.code" />
        </b-field>
      </div>

      <div class="columns">
        <!-- <b-field label="Farvekode"
                 class="column align-left"> -->
        <div class="column align-left">
          <p class="text has-text-weight-bold">Vælg farve</p>
          <v-swatches class=""
                      :value="getSelectableColorCodeByName(formCircle.colorCode)"
                      @input="formCircle.colorCode = getSelectableNameByCode($event)"
                      shapes="circles"
                      inline
                      :swatches="colors" />

        </div>
        <!-- <b-input v-model="formCircle.colorCode" /> -->
        <!-- </b-field> -->
      </div>

      <div class="columns">
        <b-field label="Tilføj dage"
                 class="column">
          <b-input v-model="formCircle.addDays"
                   type="number" />
        </b-field>
      </div>

      <div class="columns">
        <b-field label="Gruppe"
                 class="column">

          <b-select expanded
                    placeholder="Ingen gruppe"
                    v-model="formCircle.groupId">
            <option :value="null">Ingen gruppe</option>
            <option v-for="group in groups"
                    :key="group.id"
                    :value="group.id">{{ group.title }}</option>
          </b-select>
        </b-field>
      </div>

      <div class="buttons columns">
        <div class="column align-right">
          <button class="button is-primary"
                  @click="createOrUpdate">
            {{ this.isNew ? "Opret" : "Opdater"}}
          </button>
        </div>
      </div>
    </div>

    <b-loading :is-full-page="true"
               v-model="isLoading" />
  </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  userSelectColors,
  defaultUserSelectColor,
  getSelectableColorCodeByName,
  getSelectableNameByCode,
} from "@/util";

export default {
  data: () => ({
    formCircle: {
      colorCode: defaultUserSelectColor,
      type: "WORK",
    },
    isNew: false,
    colors: [],
  }),
  props: {
    circleId: {
      type: String,
      default: null,
    },
  },
  async mounted() {
    this.colors = userSelectColors;

    this.isNew = !this.circleId;

    const actions = [this.initialize()];

    if (!this.isNew) actions.push(this.getCircle(this.circleId));

    await Promise.all(actions);

    if (!this.isNew) {
      this.formCircle = this.circle;
    }
  },
  computed: {
    ...mapGetters("circles", ["circle", "circleIsLoading"]),
    ...mapGetters("groupStore", ["groups", "groupsIsLoading"]),
    isLoading() {
      return this.circleIsLoading || this.groupsIsLoading;
    },
  },
  methods: {
    ...mapActions("circles", ["getCircle", "createCircle", "updateCircle"]),
    ...mapActions("groupStore", ["initialize"]),
    getSelectableColorCodeByName,
    getSelectableNameByCode,
    async createOrUpdate() {
      try {
        if (this.isNew) {
          await this.createCircle(this.formCircle);
          this.$buefy.dialog.alert({
            type: "is-success",
            message: "Kreds oprettet",
            onConfirm: () => this.$router.push("/configuration/circles"),
          });
        } else {
          await this.updateCircle(this.formCircle);
          
          this.$buefy.dialog.alert({
            type: "is-success",
            message: "Kreds opdateret",
            onConfirm: () => this.$router.push("/configuration/circles"),
          });
        }

      } catch {
        this.$buefy.dialog.alert({
          type: "is-danger",
          message: "Kunne ikke oprette kreds",
        });
      }
    },
  },
};
</script>